import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Authorization from '../Authorization';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE } from '../../constants';

class MenuItem extends Component {
  render() {
    return (
      <li className="dropdown">
        {/* <Link
          to={this.props.to}
          tabIndex="0"
          data-submenu=""
          aria-expanded="false"
        >
          { this.props.title }
        </Link> */}
        <a href={this.props.to}>{this.props.title}</a>
        {this.props.adminTo !== '' && (
          <Authorization allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
            <ul className="dropdown-menu">
              <li>
                <Link to={this.props.adminTo}>
                  <strong>{this.props.adminTitle}</strong>
                </Link>
              </li>
            </ul>
          </Authorization>
        )}
      </li>
    );
  }
}

MenuItem.defaultProps = {
  adminTo: '',
  adminTitle: '',
};

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  adminTo: PropTypes.string,
  adminTitle: PropTypes.string,
};


export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Banner/MenuItem.js